import React from 'react';

import { KundeSigneringsordreDTO } from '../../generated-types';
import { SigningOrderStatusEnum } from '../../interfaces/StatusEnums';
import { formatDate } from '../../utils/dateUtils';
import { getDownloadSdoUrl, getSigningUrl } from '../../utils/tasksUtils';
import { TaskExpandCard } from '../TaskExpandCard';
import { SigningOrderAttachments } from './SigningOrderAttachments';
import { SigningOrderLabels } from './SigningOrderLabels';
import { SigningOrderTasks } from './SigningOrderTasks';

interface TaskItemInterface {
    signingOrder: KundeSigneringsordreDTO;
    currentUserFnr: string;
}
const SigningOrder = ({ signingOrder, currentUserFnr }: TaskItemInterface) => {
    const taskIsDone = signingOrder.status === 'ferdig_signert';
    const taskRejectedOrCancelled =
        signingOrder.status === 'kansellert' ||
        signingOrder.status === 'avvist' ||
        signingOrder.status === 'klar_for_kansellering';
    const deadlineHasPassed = signingOrder.status === 'utløpt';
    const formattedDeadline = formatDate(new Date(signingOrder.deadlineTidspunkt));
    const deadlineIsToday = formattedDeadline === formatDate(new Date());

    const signee = signingOrder.signatarer.find((signee) => signee.id === currentUserFnr);
    const signingURL = getSigningUrl(signingOrder.id, signingOrder.signatarer, currentUserFnr);
    const downloadSdoUrl = getDownloadSdoUrl(signingOrder.id, signingOrder.tittel);
    return (
        <TaskExpandCard
            title={signingOrder.tittel}
            description={signingOrder.beskrivelse}
            taskIsDone={taskIsDone || taskRejectedOrCancelled}
            deadlineHasPassed={deadlineHasPassed}
            deadlineIsToday={deadlineIsToday}
            labels={
                <SigningOrderLabels
                    signee={signee}
                    status={signingOrder.status as SigningOrderStatusEnum}
                    deadline={formattedDeadline}
                    deadlineIsToday={deadlineIsToday}
                />
            }
            tasks={
                <SigningOrderTasks
                    taskIsDone={taskIsDone}
                    deadlineHasPassed={deadlineHasPassed}
                    taskUrl={taskIsDone ? downloadSdoUrl : signingURL}
                    status={signingOrder.status}
                    signee={signee}
                    documents={signingOrder.dokumenter}
                />
            }
            attachments={<SigningOrderAttachments documents={signingOrder.dokumenter} />}
        />
    );
};

export default SigningOrder;
